$w.onReady(function () {
});

export function button16_click(event) {
	if (!$w('#searchBox1').isVisible) {
    let slideOptions = {
      "direction" : "right"
    };
    $w('#searchBox1').show('slide', slideOptions);
  } else {
    let slideOptions = {
      "direction" : "right"
    };
    $w('#searchBox1').hide('slide', slideOptions);
  }
}